import {
  Component,
  OnInit,
  Input,
  Output,
  EventEmitter,
  HostListener,
  ViewChild,
  ElementRef,
  AfterViewInit
} from '@angular/core';

@Component({
  selector: 'travel-ui-image-viewer',
  templateUrl: './image-viewer.component.html',
  styleUrls: ['./image-viewer.component.scss']
})
export class ImageViewerNewComponent implements OnInit {
  @Input() images: any;
  @Output() closeImageViewer: EventEmitter<any> = new EventEmitter();

  /** Current image details on carousel */
  activeBackground: any;
  /** Index for current image */
  activeBackgroundIndex = 0;
  sliderImages: any;
  widthToScroll = 0;
  actualWidth = 0;
  @ViewChild('imageItem', { static: true }) imageItem!: ElementRef ;
  @HostListener('document: keyup', ['event'])
  onKeyUp(event: any) {
    if (event['keyCode'] === 39) {
      this.nextImage();
    } else if (event['keyCode'] === 37) {
      this.prevImage();
    }
  }
  constructor() { }

  ngOnInit() {
    if (this.images) {
      this.activeBackground = this.images[
        this.activeBackgroundIndex
      ];
    }
  }

  scrollLeftRight(direction: any) {
    const gallery: any = document.getElementById('image-items');
    if (direction === 'left') {
      gallery.scrollLeft -= this.imageItem.nativeElement.offsetWidth;
    } else if (direction === 'right') {
      gallery.scrollLeft += this.imageItem.nativeElement.offsetWidth;
    }
  }
  /** Show previous image */
  prevImage() {
    this.activeBackgroundIndex--;
    if (this.activeBackgroundIndex < 0) {
      this.activeBackgroundIndex = this.images.length - 1;
    }
    this.activeBackground = this.images[
      this.activeBackgroundIndex
    ];
    this.scrollToImage();
  }

  /** Show next image */
  nextImage() {
    this.activeBackgroundIndex++;
    if (this.activeBackgroundIndex === this.images.length) {
      this.activeBackgroundIndex = 0;
    }

    this.activeBackground = this.images[
      this.activeBackgroundIndex
    ];
    this.scrollToImage();
  }

  /** Scroll image carousel */
  scrollToImage() {
    this.sliderImages = document.querySelectorAll('.image-item');
    this.sliderImages[this.activeBackgroundIndex]?.scrollIntoView({
      behavior: 'smooth',
      block: 'start'
    });
  }

  updateCarouselArray() {
    document.querySelector('.image-items')?.scrollTo(96, 0);
  }
  setActiveImage(index: any) {
    this.activeBackgroundIndex = index;
    this.activeBackground = this.images[index];
  }

  onClose() {
    this.closeImageViewer.emit();
  }
}
